/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".print-title[_ngcontent-%COMP%]{color:#e56c11!important;font-weight:700}"];
export { styles as styles };
